import { ReactNode } from "react";
import { Col, Span } from "@ir/ui";

interface EditProgramDetailsColProps {
  label?: string;
  children?: ReactNode;
  span?: number;
  md?: number;
  className?: string;
}

const EditProgramDetailsCol = ({ label, children, span = 6, md = 3, className }: EditProgramDetailsColProps) => {
  return (
    <Col span={span} md={md} className={className}>
      {label && <Span className="text-grey-600 font-regular text-xs mb-0">{label}</Span>}
      {children}
    </Col>
  );
};

export default EditProgramDetailsCol;
